const apiUrl = "https://api.redea.allele.ac";
export default apiUrl;